// extracted by mini-css-extract-plugin
module.exports = {"UpperCase":"Flight_UpperCase__3mA4j","FlightData":"Flight_FlightData__1nd7u","Title":"Flight_Title__17H_0"};